import * as React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function Hero() {
  return;
}